import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { MemberInvitationService } from './data-access-member-invitation/member-invitation.service';
import { ProfileMemberInviteDetails } from './domain/model/member-invitation.model';

export const memberInvitationResolver = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): Observable<ProfileMemberInviteDetails | null> => {
  const memberInvitationService = inject(MemberInvitationService);
  const activationCode = route.params['activationCode'];

  return memberInvitationService.getDetailsFromToken(activationCode).pipe(
    catchError((e) => {
      console.error(e);
      return of(null);
    }),
  );
};
